import { IntlShape } from 'react-intl'
import * as yup from 'yup'

import { ILocationRemoveForm } from 'features/RoutingProjects/types'

export const schema = (intl: IntlShape): yup.SchemaOf<ILocationRemoveForm> => {
  return yup.object().shape({
    dows: yup
      .array()
      .of(yup.mixed())
      .min(
        1,
        intl.formatMessage({
          id: 'routingProjects.locationDragEnd.dows.required',
          defaultMessage: 'Select at least one day of the week'
        })
      )
  })
}
